import { render, staticRenderFns } from "./announcementsTable.vue?vue&type=template&id=73cf0588"
import script from "./announcementsTable.vue?vue&type=script&lang=js"
export * from "./announcementsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports